import React from 'react';
import style from './style.module.scss';
import { BackButton } from '..';

export const NotFound = () => {
  return (
    <>
      <div className={style.back}>
        <BackButton link="/" />
      </div>

      <div className={style.wrapper}>
        <h1 data-t="404" className={style.title}>
          404
        </h1>
      </div>
    </>
  );
};
